module.exports = __webpack_public_path__ + "static/media/nightmare.5701b00f.svg";